"use strict";

var LoggerInstance = require("js-logger").get("BluefinHelper");

var StringConstants = require("../constants/StringConstants");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var BootstrapPrompt = require("../shared/BootstrapPrompt");
var HtmlHelper = require("../shared/HtmlHelper");

var BluefinHelper = {
	//parentSelector can be a jQuery object or jQuery selector
	clearHostedIFrame: function(parentSelector) {
		var bluefinIframeId = this.getBluefinIframeId(parentSelector);

		var iframePayment = new PaymentiFrame({
			create: false,
			iframeId: bluefinIframeId
		});

		iframePayment.clear();
	},

	//parentSelector can be a jQuery object or jQuery selector
	getBluefinHostedPageToken: function (parentSelector, creditCardErrorMessages, eftErrorMessages, successCallback, errorCallback) {
		var bluefinIframeId = this.getBluefinIframeId(parentSelector);
		var type;
		if ($(`#${bluefinIframeId}`).closest("[data-component='bluefinCreditCardPayment']").length) {
			type = "CC";
		} else if ($(`#${bluefinIframeId}`).closest("[data-component='bluefinEftPayment']").length) {
			type = "EFT";
		}

		var iframePayment = new PaymentiFrame({
			create: false,
			iframeId: bluefinIframeId
		});

		//Creating the Bluefin hostedPageToken
		iframePayment.encrypt()
			.failure(error => {
				BootstrapPrompt.alert(type === "CC" ? creditCardErrorMessages.catchAllMessage : eftErrorMessages.catchAllMessage);
				LoggerInstance.error("Error: Bluefin Tokenization Failure:", error);
				Dispatcher.dispatch({
					actionType: Constants.CHECKOUT_BLUEFIN_TOKENIZATION_FAILED
				});
				errorCallback();
			})
			.invalidInput(error => {
				var wholeMessage = "";

				var catchAllMessage = (type === "CC" ? creditCardErrorMessages.catchAllMessage : eftErrorMessages.catchAllMessage);

				error.invalidInputs.forEach(input => {
					var message = "";
					switch (input.code) {
						case StringConstants.BluefinErrorCodes.BlankField:
							switch (input.field) {
								case StringConstants.BluefinFieldNames.CreditCard:
									message = creditCardErrorMessages.blankCreditCard;
									break;
								case StringConstants.BluefinFieldNames.Expiration:
									message = creditCardErrorMessages.blankExpiration;
									break;
								case StringConstants.BluefinFieldNames.Cvv:
									message = creditCardErrorMessages.blankCvv;
									break;
								case StringConstants.BluefinFieldNames.BankAccount:
									message = eftErrorMessages.blankBankAccountNumber;
									break;
								case StringConstants.BluefinFieldNames.RoutingNumber:
									message = eftErrorMessages.blankRoutingNumber;
									break;
								default: message = catchAllMessage;
							}
							break;
						case StringConstants.BluefinErrorCodes.InputTooShort:
							switch (input.field) {
								case StringConstants.BluefinFieldNames.CreditCard:
									message = creditCardErrorMessages.shortInputCreditCard;
									break;
								case StringConstants.BluefinFieldNames.Expiration:
									message = creditCardErrorMessages.shortInputExpiration;
									break;
								case StringConstants.BluefinFieldNames.Cvv:
									message = creditCardErrorMessages.shortInputCvv;
									break;
								case StringConstants.BluefinFieldNames.BankAccount:
									message = eftErrorMessages.shortInputBankAccountNumber;
									break;
								case StringConstants.BluefinFieldNames.RoutingNumber:
									message = eftErrorMessages.shortInputRoutingNumber;
									break;
								default: message = catchAllMessage;
							}
							break;
						case StringConstants.BluefinErrorCodes.InputTooLong:
							switch (input.field) {
								case StringConstants.BluefinFieldNames.CreditCard:
									message = creditCardErrorMessages.longInputCreditCard;
									break;
								case StringConstants.BluefinFieldNames.Expiration:
									message = creditCardErrorMessages.longInputExpiration;
									break;
								case StringConstants.BluefinFieldNames.Cvv:
									message = creditCardErrorMessages.longInputCvv;
									break;
								default: message = catchAllMessage;
							}
							break;
						case StringConstants.BluefinErrorCodes.InputNotNumeric:
							switch (input.field) {
								case StringConstants.BluefinFieldNames.CreditCard:
									message = creditCardErrorMessages.nonNumericCreditCard;
									break;
								case StringConstants.BluefinFieldNames.Expiration:
									message = creditCardErrorMessages.nonNumericExpiration;
									break;
								case StringConstants.BluefinFieldNames.Cvv:
									message = creditCardErrorMessages.nonNumericCvv;
									break;
								case StringConstants.BluefinFieldNames.BankAccount:
									message = eftErrorMessages.nonNumericBankAccountNumber;
									break;
								case StringConstants.BluefinFieldNames.RoutingNumber:
									message = eftErrorMessages.nonNumericRoutingNumber;
									break;
								default: message = catchAllMessage;
							}
							break;
						case StringConstants.BluefinErrorCodes.InvalidCreditCard:
							message = creditCardErrorMessages.invalidCreditCard;
							break;
						case StringConstants.BluefinErrorCodes.InvalidExpiration:
							message = creditCardErrorMessages.invalidExpiration;
							break;
						default: message = catchAllMessage;
					}

					wholeMessage += `${message}\n`;
				});

				BootstrapPrompt.alert(wholeMessage);
				LoggerInstance.error("Error: Bluefin Tokenization Invalid Input:", error);
				Dispatcher.dispatch({
					actionType: Constants.CHECKOUT_BLUEFIN_TOKENIZATION_FAILED
				});
				errorCallback();
			})
			.success(response => {
				Dispatcher.dispatch({
					actionType: Constants.CHECKOUT_BLUEFIN_TOKENIZATION_SUCCESS
				});

				//Callback to process eToken
				successCallback({
					hostedPageToken: response.eToken,
					type
				});
			});
	},

	//parentSelector can be a jQuery object or jQuery selector
	getBluefinIframeId(parentSelector) {
		parentSelector = parentSelector || "body";

		var newId = HtmlHelper.getId($("body"));
		var $iframe = $(parentSelector).find("div[data-component='bluefinCreditCardPayment'] iframe:visible,div[data-component='bluefinEftPayment'] iframe:visible");
		if ($iframe.length) {
			$iframe.attr("id", newId);
			return newId;
		}

		return null;
	}
};

module.exports = BluefinHelper;



// WEBPACK FOOTER //
// ./Javascript/commonComponents/BluefinHelper.jsx